<template lang="pug">
.header
  ManagementPage(:title="$t(`${baseTranslation}.title`)"
                :info="$t(`${baseTranslation}.description`)"
                :creatable="false"
                :searchable="false")

.shared-auth-config
  .oauth-configuration
    .form-container
      .sub-header--solid {{ title }}
      .form__inner-content
        .form-field-container
          .form-field-label {{ $t(`${baseTranslation}.interpreter`) }}
          aiq-tooltip.help-icon(placement="right")
            template(v-slot:content)
              div(v-html="$t(`${baseTranslation}.interpreter_tooltip`)")
            i.iq-ico-explanation(class="tooltip-help-icon")
          aiq-select.input(v-model="config.interpreter" class="select-input" size="small")
            aiq-option(v-for="option in externalInterpreter"
                          :key="option.value"
                          :label="option.label"
                          :value="option.value")
        .form-field-container
          .form-field-label {{ $t(`${baseTranslation}.interpreter_access_token`) }}
          aiq-tooltip.help-icon(placement="right")
            template(v-slot:content)
              div(v-html="$t(`${baseTranslation}.interpreter_access_token_tooltip`)")
            i.iq-ico-explanation(class="tooltip-help-icon")
          aiq-input.input(v-model="config.interpreter_access_token"
                    :placeholder="$t(`${baseTranslation}.interpreter_access_token`)"
                    size="small"
                    type="password")
        .form-field-container
          .form-field-label {{ $t(`${baseTranslation}.interpreter_endpoint`) }}
          aiq-tooltip.help-icon(placement="right")
            template(v-slot:content)
              div(v-html="$t(`${baseTranslation}.interpreter_endpoint_tooltip`)")
            i.iq-ico-explanation(class="tooltip-help-icon")
          aiq-input.input(v-model="config.interpreter_endpoint"
                    :placeholder="$t(`${baseTranslation}.interpreter_endpoint`)"
                    size="small")
        .form-field-container
            aiq-button(@click="saveCredentials()" type="primary") {{ $t(`global.save`) }}
</template>

<script>
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';

export default {
  name: 'ExternalBackendAi',
  components: {
    ManagementPage,
  },
  computed: {
    title() {
      return this.$t(`${this.baseTranslation}.title`);
    },
    name() {
      return this.$t(`${this.baseTranslation}.name`);
    },
  },
  async mounted() {
    this.externalInterpreter = await this.$store.dispatch('integrations/getExternalAIBackend');
    if (!this.name) {
      throw new Error(`name attribute should be set to use this component but ${this.name}`);
    }

    this.config = await this.$store.dispatch('integrations/getIntegration', { name: this.name });
  },
  methods: {
    async saveCredentials() {
      try {
        this.config = await this.$store.dispatch('integrations/updateIntegration', {
          name: this.name,
          payload: this.config,
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(`Failed: ${err.message}`);
      }
    },
  },
  data() {
    return {
      config: {'interpreter': null, 'interpreter_access_token': null, 'interpreter_endpoint': null},
      externalInterpreter: [],
      baseTranslation: 'settings_tab.integraions_tab.external_ai_backend',
    };
  },
};
</script>

<style lang="scss" scoped>
.form__inner-content {
  background: #FFFFFF;
  border: 1px solid #E0E6ED;
  display: flex;
  flex-direction: column;
  padding: 18px;
}

.form-field-container {
  margin-bottom: 5px;
  margin-top: 5px;
  display: flex;
  gap: 5px;
  width: 100%;
}

.form-field-label {
  font-weight: 500;
}

.input {
    padding-left: 20px;
}

.select-input {
  width: 23%;
}
</style>
